import DB_FIELD_LENGTH_MAP from './dbFieldLengthMap'

const LENGTH_ERROR_TEMPLATE = '该字符串不能大于{max}长度'

function camelToSnake(value) {
    return String(value || '')
        .replace(/([A-Z])/g, '_$1')
        .replace(/__/g, '_')
        .toLowerCase()
        .replace(/^_/, '')
}

function formatLengthError(max) {
    return LENGTH_ERROR_TEMPLATE.replace('{max}', max)
}

export function getStringLength(value) {
    return Array.from(String(value || '')).length
}

export function hasRequiredValue(value) {
    if (Array.isArray(value)) return value.length > 0
    if (typeof value === 'string') return value.trim().length > 0
    return value !== undefined && value !== null && value !== ''
}

export function getDbFieldMaxLength(tableName, fieldName) {
    const table = DB_FIELD_LENGTH_MAP[String(tableName || '')]
    if (!table) return 0

    if (Object.prototype.hasOwnProperty.call(table, fieldName)) {
        return Number(table[fieldName] || 0)
    }

    const snakeFieldName = camelToSnake(fieldName)
    return Number(table[snakeFieldName] || 0)
}

export function getDbFieldLengthError(tableName, fieldName, value) {
    const maxLength = getDbFieldMaxLength(tableName, fieldName)
    if (!maxLength || !hasRequiredValue(value)) return ''
    return getStringLength(value) > maxLength ? formatLengthError(maxLength) : ''
}

export function createDbFieldLengthRule(tableName, fieldName) {
    return {
        trigger: ['blur', 'change'],
        validator(rule, value, callback) {
            const errorMessage = getDbFieldLengthError(tableName, fieldName, value)
            if (errorMessage) {
                callback(new Error(errorMessage))
                return
            }
            callback()
        }
    }
}

export function buildDialogLengthErrors(form, tableName, fieldNames = []) {
    return fieldNames.reduce((result, fieldName) => {
        result[fieldName] = getDbFieldLengthError(tableName, fieldName, form?.[fieldName])
        return result
    }, {})
}

export function isDialogSubmitDisabled({ visible = true, form = {}, requiredFields = [], tableName = '', lengthFields = [] }) {
    if (!visible) return true

    if (requiredFields.some(fieldName => !hasRequiredValue(form?.[fieldName]))) {
        return true
    }

    return lengthFields.some(fieldName => Boolean(getDbFieldLengthError(tableName, fieldName, form?.[fieldName])))
}

export function appendDbLengthRules(baseRules = {}, tableName, fieldNames = []) {
    const nextRules = { ...baseRules }
    fieldNames.forEach((fieldName) => {
        const maxLength = getDbFieldMaxLength(tableName, fieldName)
        if (!maxLength) return
        const currentRules = Array.isArray(nextRules[fieldName]) ? [...nextRules[fieldName]] : []
        currentRules.push(createDbFieldLengthRule(tableName, fieldName))
        nextRules[fieldName] = currentRules
    })
    return nextRules
}
